var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Browser from '@tap-payments/browser-info';
import { generateApplicationHeader, encryptString } from '../../utils';
import { Theme, Locale, Direction } from '../../types';
import CardIframe from './iframe';
import Loader from './Loader';
import { createRoot } from 'react-dom/client';
import { mapingCardFundingSource } from '../../utils/mapping';
var IframeId;
var framePath;
function getframePath(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    return __awaiter(this, void 0, void 0, function () {
        var publicKey, merchant, uiInterface, checkoutProfileResponse, acceptance, addons, fields, customer, transaction, browserLocale, mappedPaymentOption, encryptedHeaders, mdn, authorization, rest, application, LOCALE_BASE_URL, BASE_URL, PATH, browserTheme, appTheme;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    publicKey = props.publicKey, merchant = props.merchant, uiInterface = props.interface, checkoutProfileResponse = props.checkoutProfileResponse, acceptance = props.acceptance, addons = props.addons, fields = props.fields, customer = props.customer, transaction = props.transaction;
                    browserLocale = (_a = window.navigator.language.split('-')) === null || _a === void 0 ? void 0 : _a[0];
                    mappedPaymentOption = {
                        locale: uiInterface.locale === Locale.DYNAMIC ? browserLocale || 'en' : uiInterface.locale,
                        direction: uiInterface.direction === Direction.DYNAMIC ? undefined : uiInterface.direction,
                        showLoadingState: addons.loader,
                        collectHolderName: fields.cardHolder,
                        preLoadCardName: (_b = customer === null || customer === void 0 ? void 0 : customer.nameOnCard) !== null && _b !== void 0 ? _b : '',
                        cardNameEditable: (_c = customer === null || customer === void 0 ? void 0 : customer.editable) !== null && _c !== void 0 ? _c : true,
                        currencyCode: transaction.currency,
                        customer: customer === null || customer === void 0 ? void 0 : customer.id,
                        cardFundingSource: mapingCardFundingSource(acceptance === null || acceptance === void 0 ? void 0 : acceptance.supportedCards),
                        saveCardOption: addons.saveCard === false ? 'none' : 'all',
                        supportedPaymentMethods: acceptance === null || acceptance === void 0 ? void 0 : acceptance.supportedBrands,
                        edges: uiInterface.edges,
                        displayPaymentBrands: addons.displayPaymentBrands,
                        sortedCurrencyCode: props === null || props === void 0 ? void 0 : props.sortedCurrencyCode,
                        cardCVV: (_d = fields.cvv) !== null && _d !== void 0 ? _d : true,
                        savedCardCVV: (_e = fields.savedCardCVV) !== null && _e !== void 0 ? _e : true
                    };
                    return [4, new Browser.BrowserInfo({
                            app: {
                                name: 'web-card-sdk',
                                language: uiInterface.locale
                            },
                            credentials: {
                                mdn: window.location.origin,
                                pk: publicKey
                            },
                            encrypt: function (_key, value) { return encryptString(value); }
                        }).get()];
                case 1:
                    encryptedHeaders = _h.sent();
                    mdn = encryptedHeaders.mdn, authorization = encryptedHeaders.authorization, rest = __rest(encryptedHeaders, ["mdn", "authorization"]);
                    application = generateApplicationHeader(rest);
                    LOCALE_BASE_URL = 'http://0.0.0.0:4001';
                    BASE_URL = 'https://sdk.tap.company';
                    PATH = '/v2/card/index.html';
                    IframeId = 'tap-card-iframe';
                    browserTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? Theme.DARK : Theme.LIGHT;
                    appTheme = uiInterface.theme === Theme.DYNAMIC ? browserTheme : uiInterface.theme;
                    framePath = "".concat(BASE_URL + PATH, "?integration=").concat(props.integration || 'merchant', "&publicKey=").concat(publicKey, "&mid=").concat((_f = merchant === null || merchant === void 0 ? void 0 : merchant.id) !== null && _f !== void 0 ? _f : '', "&themeMode=").concat(encodeURIComponent(appTheme), "&paymentOptions=").concat(encodeURIComponent(JSON.stringify(mappedPaymentOption)), "&application=").concat(application, "&mdn=").concat(mdn, "&session=").concat((_g = checkoutProfileResponse === null || checkoutProfileResponse === void 0 ? void 0 : checkoutProfileResponse.session) !== null && _g !== void 0 ? _g : '');
                    return [2, framePath];
            }
        });
    });
}
export function CardElements(props) {
    var _a = React.useState(true), loading = _a[0], setLoading = _a[1];
    useEffect(function () {
        getframePath(props).finally(function () { return setLoading(false); });
    }, []);
    var defaultHeight = 95;
    var onIFrameLoaded = function () {
        var _a;
        if (props.integration === 'checkout' && ((_a = props.checkoutProfileResponse) === null || _a === void 0 ? void 0 : _a.session)) {
            setTimeout(function () { return sendCheckoutProfileData(props.checkoutProfileResponse); }, 100);
        }
    };
    if (loading)
        return (_jsx("div", __assign({ style: {
                width: '100%',
                marginLeft: 'auto',
                boxSizing: 'border-box',
                marginRight: 'auto',
                display: 'block',
                maxWidth: '500px',
                padding: '0px !important',
                position: 'relative',
                minHeight: defaultHeight,
                backgroundColor: 'inherit'
            } }, { children: _jsx(Loader, { hideSpinnerLoader: typeof props.hideSpinnerLoader === undefined ? true : props.hideSpinnerLoader, loading: false, height: defaultHeight, themeMode: props.interface.theme }) })));
    return (_jsx(_Fragment, { children: _jsx(CardIframe, { framePath: framePath, on3dsResponse: function (data) {
                var _a;
                (_a = props.onSuccess) === null || _a === void 0 ? void 0 : _a.call(props, data);
            }, onRedirectUrl: function (data) {
            }, on3dsRedirect: function (data) {
            }, on3dsFail: function (data) {
                var _a;
                (_a = props.onError) === null || _a === void 0 ? void 0 : _a.call(props, data);
            }, onTokenCreated: function (data, url) {
                var _a;
                (_a = props.onSuccess) === null || _a === void 0 ? void 0 : _a.call(props, __assign(__assign({}, data), { url: url }));
            }, onBin: function (data) {
                var _a;
                (_a = props.onBinIdentification) === null || _a === void 0 ? void 0 : _a.call(props, data);
            }, onError: function (data) {
                var _a;
                (_a = props.onError) === null || _a === void 0 ? void 0 : _a.call(props, data);
            }, onCardSaved: function (data) {
                var _a;
                (_a = props.onSuccess) === null || _a === void 0 ? void 0 : _a.call(props, data);
            }, onFocus: props.onFocus, showLoader: props.showLoader, hideSpinnerLoader: props.hideSpinnerLoader, onCompleteTyping: props.onCompleteTyping, onDetectBrand: props.onDetectBrand, onChangeSaveCardLater: props.onChangeSaveCardLater, onChangeSaveCardLaterTap: props.onChangeSaveCardLaterTap, onResetLoadedCard: props.onResetLoadedCard, isAllInputsValid: function (valid) {
                var _a, _b;
                (_a = props.onValidInput) === null || _a === void 0 ? void 0 : _a.call(props, valid);
                (_b = props.onInvalidInput) === null || _b === void 0 ? void 0 : _b.call(props, !valid);
            }, onReady: props.onReady, themeMode: props.interface.theme, height: defaultHeight, showLoadingState: props.addons.loader, onIFrameLoaded: onIFrameLoaded }) }));
}
var findOrCreateElementAndInject = function (id) {
    var elementExist = document.getElementById(id);
    if (elementExist)
        return elementExist;
    var element = document.createElement('div');
    element.setAttribute('id', id || 'tap-card-elements-sdk');
    document.body.prepend(element);
    return element;
};
export function renderCardElements(elementId, config) {
    var element = findOrCreateElementAndInject(elementId);
    var root = createRoot(element);
    root.render(_jsx(CardElements, __assign({}, config)));
    var unmount = function () { return root.unmount(); };
    return { unmount: unmount };
}
var isIFrame = function (input) { return input !== null && input.tagName === 'IFRAME'; };
function getQueryParams(url) {
    var paramArr = url.slice(url.indexOf('?') + 1).split('&');
    var params = {};
    paramArr.map(function (param) {
        var _a = param.split('='), key = _a[0], val = _a[1];
        params[key] = decodeURIComponent(val);
    });
    return params;
}
export function tokenize() {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        hideSavedCardOption();
        var query = getQueryParams(frame.src);
        var message = { event: 'tokenize', data: { publicKey: query.publicKey } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
export function saveCard() {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        hideSavedCardOption();
        var query = getQueryParams(frame.src);
        var message = { event: 'saveCard', data: { publicKey: query.publicKey } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
export function updateCardConfiguration(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = {
            event: 'updatePaymentOption',
            data: {
                publicKey: query.publicKey,
                paymentOptions: {
                    cardFundingSource: (_b = (_a = data.acceptance) === null || _a === void 0 ? void 0 : _a.supportedCards) !== null && _b !== void 0 ? _b : 'all',
                    cardNameEditable: (_d = (_c = data.customer) === null || _c === void 0 ? void 0 : _c.editable) !== null && _d !== void 0 ? _d : true,
                    collectHolderName: (_f = (_e = data.fields) === null || _e === void 0 ? void 0 : _e.cardHolder) !== null && _f !== void 0 ? _f : false,
                    currencyCode: (_g = data.transaction) === null || _g === void 0 ? void 0 : _g.currency,
                    sortedCurrencyCode: (_h = data.transaction) === null || _h === void 0 ? void 0 : _h.sortedCurrency,
                    customer: (_j = data.customer) === null || _j === void 0 ? void 0 : _j.id,
                    locale: (_k = data.interface) === null || _k === void 0 ? void 0 : _k.locale,
                    preLoadCardName: (_m = (_l = data.customer) === null || _l === void 0 ? void 0 : _l.nameOnCard) !== null && _m !== void 0 ? _m : '',
                    saveCardOption: ((_o = data.addons) === null || _o === void 0 ? void 0 : _o.saveCard) === false ? 'none' : 'all',
                    showLoadingState: (_p = data.addons) === null || _p === void 0 ? void 0 : _p.loader,
                    displayPaymentBrands: (_q = data.addons) === null || _q === void 0 ? void 0 : _q.displayPaymentBrands,
                    direction: (_r = data.interface) === null || _r === void 0 ? void 0 : _r.direction
                }
            }
        };
        frame.contentWindow.postMessage(message, framePath);
    }
}
export function updateTheme(theme) {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = { event: 'updateThemeMode', data: { publicKey: query.publicKey, theme: theme } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
function updatePublicKey(data) {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = { event: 'updatePublicKey', data: { publicKey: query.publicKey, newPublicKey: data } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
function threeDsRedirect(data) {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = { event: 'threeDsRedirect', data: { publicKey: query.publicKey, threeDsObject: data } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
export function loadSavedCard(cardId) {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = { event: 'loadSavedCard', data: { publicKey: query.publicKey, cardId: cardId } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
export function hideSavedCardOption(flag) {
    if (flag === void 0) { flag = true; }
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = { event: 'hideSavedCardOption', data: { publicKey: query.publicKey, hide: flag } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
function onDetectBrand(data) {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = { event: 'brand', data: { publicKey: query.publicKey, brand: data } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
export function resetCardInputs() {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        hideSavedCardOption(false);
        var message = { event: 'reset', data: { publicKey: query.publicKey } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
export function removeCardErrorMessage(flag) {
    if (flag === void 0) { flag = true; }
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = { event: 'hideErrorFooter', data: { publicKey: query.publicKey, hide: flag } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
function sendCheckoutProfileData(data) {
    var frame = document.getElementById(IframeId);
    if (isIFrame(frame) && frame.contentWindow) {
        var query = getQueryParams(frame.src);
        var message = { event: 'cardMetaData', data: { publicKey: query.publicKey, cardMetaData: data } };
        frame.contentWindow.postMessage(message, framePath);
    }
}
